import React, { useState } from 'react';
import { MoreVertical, Copy, AlertTriangle, UserX } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { ReportUserDialog } from './ReportUserDialog';
import { BlockUserDialog } from './BlockUserDialog';

interface ProfileActionsDropdownProps {
  profile: any;
  currentUrl: string;
}

export const ProfileActionsDropdown: React.FC<ProfileActionsDropdownProps> = ({
  profile,
  currentUrl,
}) => {
  const [showReportDialog, setShowReportDialog] = useState(false);
  const [showBlockDialog, setShowBlockDialog] = useState(false);

  const handleCopyProfile = () => {
    navigator.clipboard.writeText(currentUrl);
    toast.success('Profile link copied to clipboard');
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem onClick={handleCopyProfile}>
            <Copy className="mr-2 h-4 w-4" />
            Copy Profile
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => setShowReportDialog(true)}
            className="text-destructive focus:text-destructive"
          >
            <AlertTriangle className="mr-2 h-4 w-4" />
            Report User
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => setShowBlockDialog(true)}
            className="text-destructive focus:text-destructive"
          >
            <UserX className="mr-2 h-4 w-4" />
            Block User
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ReportUserDialog
        open={showReportDialog}
        onOpenChange={setShowReportDialog}
        reportedUser={profile}
      />

      <BlockUserDialog
        open={showBlockDialog}
        onOpenChange={setShowBlockDialog}
        userToBlock={profile}
      />
    </>
  );
};